import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ShoppingProvider } from "@/context/ShoppingContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import AppNavbar from "@/components/AppNavbar";
import HomePage from "./pages/HomePage";
import ComparePage from "./pages/ComparePage";
import ShoppingListPage from "./pages/ShoppingListPage";
import SavedListsPage from "./pages/SavedListsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ProfilePage from "./pages/ProfilePage";
import VerifyOtpPage from "./pages/VerifyOtpPage";
import NotFound from "./pages/NotFound";
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSearches from "./pages/admin/AdminSearches";
import AdminCache from "./pages/admin/AdminCache";
import AdminCatalog from "./pages/admin/AdminCatalog";
import AdminStores from "./pages/admin/AdminStores";
import AdminAnnouncements from "./pages/admin/AdminAnnouncements";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <ShoppingProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<main><LoginPage /></main>} />
              <Route path="/forgot-password" element={<main><ForgotPasswordPage /></main>} />
              <Route path="/reset-password" element={<main><ResetPasswordPage /></main>} />
              <Route path="/register" element={<main><RegisterPage /></main>} />
              <Route path="/verify-otp" element={<main><VerifyOtpPage /></main>} />
              <Route path="/set-password" element={
                <ProtectedRoute><main><SetPasswordPage /></main></ProtectedRoute>
              } />
              <Route path="/" element={
                <ProtectedRoute><AppNavbar /><main><HomePage /></main></ProtectedRoute>
              } />
              <Route path="/compare" element={
                <ProtectedRoute><AppNavbar /><main><ComparePage /></main></ProtectedRoute>
              } />
              <Route path="/list" element={
                <ProtectedRoute><AppNavbar /><main><ShoppingListPage /></main></ProtectedRoute>
              } />
              <Route path="/saved" element={
                <ProtectedRoute><AppNavbar /><main><SavedListsPage /></main></ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute><AppNavbar /><main><ProfilePage /></main></ProtectedRoute>
              } />
              <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="searches" element={<AdminSearches />} />
                <Route path="cache" element={<AdminCache />} />
                <Route path="catalog" element={<AdminCatalog />} />
                <Route path="stores" element={<AdminStores />} />
                <Route path="announcements" element={<AdminAnnouncements />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ShoppingProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
